import { printConstants, authConstants } from '../constants';
import { LocalStorage, PrintPage } from '../helper';
import { MessagesActions } from './';
import { PrintApi } from '../services';
import uuidv4 from 'uuid/v4';
import moment from 'moment';

const {REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME} = process.env;

export class PrintActions {
    /**
     * create print list in store & localStorage
     */
    static createPrintList({images, frame, printed, printID, rotate, storeInLocalStorage, imagesPerPage}) {
        return (dispatch) => {
            const payload = {
                printID: printID || uuidv4(),
                images: images,
                frame: frame,
                printed: printed,
                rotate: rotate,
                imagesPerPage: imagesPerPage
            }

            dispatch({type: printConstants.CREATE_PRINT_LIST, payload: payload});

            // for sync between browser tabs
            if(storeInLocalStorage) PrintActions.savePrintInLocalStorage(payload);
            return payload.printID;
        }
    }

    /**
     * print all images
     */
    static createPagePrintList({images, frame, printed}) {
        return (dispatch) => {
            const pageImages = new PrintPage({
                images: images,
                frameSize: {
                    width: frame.size.x,
                    height: frame.size.y
                },
                page: frame.page
            });

            const list = pageImages.all();
            const rotate = pageImages.rotate;
            const imagesPerPage = pageImages.imagesPerPage;

            if(list.length === 0) {
                dispatch(MessagesActions.pushInfo("אין תמונות להדפסה (הוסיפו עותקים לתמונות שברצונכם להדפיס)"));
                return;
            }

            const printID = dispatch(PrintActions.createPrintList({
                images: list, 
                frame: frame, 
                printed: printed, 
                rotate: rotate, 
                imagesPerPage: imagesPerPage,
                storeInLocalStorage: true
            }));
            PrintActions.openPrintPageInNewTab(printID);
        }
    }

    /**
     * print only full page 
     */
    static createFullPagePrintList({images, frame, printed}) {
        return (dispatch) => {
            const pageImages = new PrintPage({
                images: images,
                frameSize: {
                    width: frame.size.x,
                    height: frame.size.y
                },
                page: frame.page
            });

            const list = pageImages.fullPage();
            const rotate = pageImages.rotate;
            const imagesPerPage = pageImages.imagesPerPage;

            if(list) {
                const printID = dispatch(PrintActions.createPrintList({
                    images: list, 
                    frame: frame, 
                    printed: printed, 
                    rotate: rotate, 
                    imagesPerPage: imagesPerPage,
                    storeInLocalStorage: true
                }));
                PrintActions.openPrintPageInNewTab(printID);
            } else {
                dispatch(MessagesActions.pushError(`חסרים לך ${imagesPerPage - pageImages.imagesForPrint} עותקים כדי למלא דף להדפסה`));
            }
        }
    }

    static deletePrintList(printID) {
        return (dispatch) => {
            dispatch({type: printConstants.DELETE_PRINT_LIST, payload: {printID: printID}});
        }
    }

    static successfullyPrint(printID) {
        return (dispatch) => {
            PrintActions.setPrintSuccessInLocalStorage(printID);
            dispatch({type: printConstants.SUCCESSFULLY_PRINT, payload: {printID: printID}});
        }   
    }

    static savePrintInLocalStorage({printID, images, printed, frame, rotate, imagesPerPage}) {
        const name = REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME;
        
        const newItem = {
            printID: printID,
            images: images,
            frame: frame,
            printed: printed,
            rotate: rotate,
            imagesPerPage: imagesPerPage,
            timestamp: moment().format()
        }

        let lsItem = LocalStorage.get(name);
        if(Array.isArray(lsItem)) {
            let newList = [];

            // clean localStorage from outdated print lists (older then 2 days)
            lsItem.forEach((item) => {
                if(item.timestamp && moment(item.timestamp).add('2', 'days') > moment()) {
                    newList.push(item);
                }
            });

            newList.push(newItem); // at the end (so print page will dispatch only the new items)

            LocalStorage.set(name, newList);
        } else {
            LocalStorage.set(name, [newItem]);
        }
    }

    static setPrintSuccessInLocalStorage(printID) {
        const name = REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME;
        const old = LocalStorage.get(name);
        if(!Array.isArray(old)) return;

        const updated = old.map((item) => {
            if(item.printID === printID) {
                item.printed = true;
            }
            return item;
        });

        LocalStorage.set(name, updated);
    }

    static openPrintPageInNewTab(printID) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = `./print/${printID}`;
        a.click();
    }

    static updateBulkImages(eventID, printID, data) {
        return (dispatch) => {
            dispatch({type: printConstants.UPDATE_BULK_IMAGES_PRINT_REQUEST});

            PrintApi.updateBulkImages(eventID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: printConstants.UPDATE_BULK_IMAGES_PRINT_SUCCESS});
                        dispatch(PrintActions.successfullyPrint(printID));
                        dispatch(MessagesActions.pushSuccess('התמונות עודכנו בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('לא ניתן לעדכן את התמונות אנא נסו שנית'));
                    return dispatch({type: printConstants.UPDATE_BULK_IMAGES_PRINT_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: printConstants.UPDATE_BULK_IMAGES_PRINT_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שנית'));
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/print.js